module.exports = __webpack_public_path__ + "img/lauch.e046facc.png";